// extracted by mini-css-extract-plugin
module.exports = {"mainNav":"MainNavigation_mainNav__37Ihm","active":"MainNavigation_active__nFvaJ"};